var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserDropdownIcon05(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.16669 5.24635C1.16669 3.31537 2.728 1.75 4.66707 1.75H9.33294C11.2662 1.75 12.8334 3.32195 12.8334 5.24635V12.25H4.66707C2.73386 12.25 1.16669 10.678 1.16669 8.75367V5.24635ZM11.6667 11.0833V5.24635C11.6667 3.96398 10.6195 2.91667 9.33294 2.91667H4.66707C3.37436 2.91667 2.33335 3.95767 2.33335 5.24635V8.75367C2.33335 10.036 3.38051 11.0833 4.66707 11.0833H11.6667ZM8.16669 6.41667H9.33335V7.58333H8.16669V6.41667ZM4.66669 6.41667H5.83335V7.58333H4.66669V6.41667Z",
    fill: "#1B1B1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserDropdownIcon05);
export default __webpack_public_path__ + "static/media/user-dropdown-icon--05.468b32e3fde3588cad72e4de1d128557.svg";
export { ForwardRef as ReactComponent };